@if (useSelect) {
  <mat-form-field appearance="outline" class="w-100">
    <mat-label rtI18n>Language</mat-label>
    <mat-select [value]="currentLanguageId" (selectionChange)="onSelectChange($event.value)" [disabled]="disabled">
      @for (lang of languages; track lang.Id) {
        <mat-option [value]="lang.Id">
          {{ lang.LanguageName }}
          @if (!lang.IsSupportedInAzure) {
            <span rtI18n> (Not Supported)</span>
          }
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
} @else {
  <button type="button" mat-menu-item data-testid="menu-language-item" [matMenuTriggerFor]="languageMenu" #languageTrigger="matMenuTrigger" (mouseenter)="languageTrigger.openMenu()">
    <div style="display: flex; align-items: center; gap: 4px;">
      <i class="icon-language icon-text-blue"></i>
      <span rtI18n>Language</span>
    </div>
  </button>

  <mat-menu #languageMenu="matMenu" class="language-menu">
    <div style="padding: 8px 0;">
      @for (lang of languages; track lang) {
        <button type="button"
          mat-menu-item
          (click)="changeLanguage(lang.AzureLanguageCode)"
          [class.active]="lang.Id === currentLanguageId">
          {{ lang.LanguageName }}
          @if (!lang.IsSupportedInAzure) {
            <span rtI18n>(Not Supported)</span>
          }
          @if (lang.Id === currentLanguageId) {
            <i class="icon-check" style="margin-left: 8px;"></i>
          }
        </button>
      }
    </div>
  </mat-menu>
}
